import Profile from "../../../../components/common/profile/mobile";

export default function ProfileView() {
  return <Profile />;
}
